// deployment_class: customer_env_allowed
/**
 * SkipLink — first focusable element of every portal route. Design System
 * spec §9.3 (keyboard operability — Skip link).
 *
 * Visually hidden until focused, then displays a high-contrast pill in the
 * top-left so keyboard users can bypass the persistent TopBar nav and jump
 * directly to <main> content. The href targets the id="main-content"
 * landmark (rendered by App.tsx on the <main> element).
 *
 * Usage:
 *   <SkipLink />   // Render BEFORE the TopBar so it's the very first
 *                  // focusable element in the tab order.
 */
export function SkipLink(): JSX.Element {
  return (
    <a
      href="#main-content"
      className="
        sr-only
        focus:not-sr-only
        focus:fixed focus:top-2 focus:left-2 focus:z-50
        focus:px-3 focus:py-2
        focus:bg-trust focus:text-paper
        focus:font-medium focus:text-body-s
        focus:outline-none focus:ring-2 focus:ring-amber
        focus:no-underline
      "
    >
      Skip to main content
    </a>
  );
}
